export default __webpack_public_path__ + "static/media/16.6b92465d.jpg";